import request from '@/utils/request'

// 查询列表
export function apiMdmItemMaintenanceProduceList (query) {
  return request({
    url: '/mdm/mdmItemMaintenance/produceList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemMaintenanceNewExport (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/v2/produceExport',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMdmItemMaintenanceProduceEdit (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/produceEdit',
    method: 'put',
    data: data
  })
}
